module.exports = __webpack_public_path__ + "static/media/portugues.0cdf917d.svg";